import { VStack, Heading, Button, Box,  Tag, Flex, Spacer, HStack,  Select } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import  {NftGrid}  from '../components/NftGrid';
import { useMoralis } from 'react-moralis';
import '../index.css';




export const Nfts = () => {

  const [refreshKey, setRefreshKey]=useState('0');
  const { account } = useMoralis();
  const [address, setAddress] = useState<string>(account || '');
  const [chain] = useState<string>('0x19');
  const [searchChain, setSearchChain] = useState<string>('0x19');
  const [searchAddress, setSearchAddress] = useState<string>(account || '');
  const [value, setValue] = React.useState('0xf96ec7C11D311920833753FAB9b174B6FD53517E')
  const [tokenaddresses, setTokenaddresses] = useState([String('0xf96ec7C11D311920833753FAB9b174B6FD53517E')]);
  const [allCollections, setAllCollections] = useState<[string, string][]>([]);


 
 
 
  useEffect(() => {
    if (!address && account) {
      setAddress(account);
  
    }
  }, [account, address, value]);

  useEffect(() => {
  setRefreshKey(refreshKey+'1');
      setTokenaddresses([value]);
      console.log(value);
    
  }, [value]);
  
  const [data, setData] = useState(null);

      
  const url1="https://api.cronoscan.com/api?module=account&action=tokenbalance&contractaddress="+value+"&address="
  const url2= String(address)
  const url3= "&tag=latest&apikey=57VGVCF7UM4H74I2XA5AJ4WC4TAI2TJDKC"
  
  

    useEffect(() => {
      const fetchData = async () => {
        const response = await fetch(url1+url2+url3);
        const json = await response.json();
        setData(json);

      
      };
    // eslint-disable-next-line
      fetchData();
    
      
    }, [value]);
    
    
  const [data2, setData2] = useState(null);

      
  const url12="https://api.cronoscan.com/api?module=account&action=tokenbalance&contractaddress="+value+"&address="
  const url22= '0x000000000000000000000000000000000000dead'
  const url32= "&tag=latest&apikey=57VGVCF7UM4H74I2XA5AJ4WC4TAI2TJDKC"
  
  

    useEffect(() => {
      const fetchData2 = async () => {
        const response2 = await fetch(url12+url22+url32);
        const json2 = await response2.json();
        setData2(json2);
      
      };
    // eslint-disable-next-line
      fetchData2();
    
    }, [value]);

    const [sortField, setSortField] = useState<'name' | 'token_id'>('token_id');
const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

/* THIS IS regarding RECK holdings
  <Flex wrap="nowrap"  direction= 'row'   justify-content= 'space-between' >
      
      <Tag colorScheme='white' fontSize={'1vw'} boxSize={'fit-content'} margin= '2em' >{data ? <p>RECK BALANCE:        {(data)['result']} </p> : <p>Loading...</p>}</Tag>
  
      <Tag  colorScheme='white' fontSize={'1vw'} boxSize={'fit-content'} margin= '2em'>{data && data2 ?  <p>PERCENTAGE OWNED: - {(((data)['result']/(2100-data2['result']))*100).toFixed(2)} % </p> : <p>Loading...</p>}</Tag>
        <Spacer paddingBottom={5}></Spacer>
        </Flex>*/
  
  return (
    
    <VStack    border="1px solid"
    borderColor={'white'}
    borderRadius="2xl" padding={'3vmax'} color={'white'} alignItems={'center'} background={'blackAlpha.700'}    backdropFilter="blur(12px)">
    
      <Box width="full">
    
      <form
          onSubmit={(event) => {
            event.preventDefault();
            setSearchAddress(address);
            setSearchChain(chain);
            setRefreshKey(refreshKey+'2');
            console.log(refreshKey);
          }}
        >
          <VStack   textAlign="center"     
             
            
             
                >
            
           
             
           
          <Button   
                 bg={'whiteAlpha.600'} boxShadow="xl" className='nft-button'  type="submit" fontSize={'1.3vw'} boxSize='full' minWidth={'-moz-fit-content'}>
              REFRESH NFTs
            </Button>
          </VStack>
        </form>
      </Box>

      {searchAddress && (
        <Box backgroundColor={'transparent'} pt={8}>
          <Heading size={'md'} mb={4}>
          <Tag  fontSize='1vw' colorScheme={'whiteAlpha'}>NFTs FOR {searchAddress}</Tag> 
       
          </Heading>
          <Flex wrap="nowrap" gap={4} marginTop={4} alignItems={'center'}>
          <Select
  placeholder="Filter by Collection"
  onChange={(e) => setValue(e.target.value)}
  value={value}
  fontSize="1vw"
  width="fit-content"
   bg="whiteAlpha.700"
  color="white"
  className='nft-button'
>
{allCollections?.map(([addr, name]) => (
  <option key={addr} value={addr}>
    {name}
  </option>
))}

</Select>
  <Select
    placeholder='Sort by'
    value={sortField}
    onChange={(e) => setSortField(e.target.value as 'name' | 'token_id')}
    fontSize="1vw"
    width="auto"
      bg="whiteAlpha.700"
    color="white"
    className='nft-button'
  >
    <option value="name">Collection Name</option>
    <option value="token_id">Token ID</option>
  </Select>
  <Select
    placeholder='Order'
    value={sortOrder}
    onChange={(e) => setSortOrder(e.target.value as 'asc' | 'desc')}
    fontSize="1vw"
    width="auto"
    bg="whiteAlpha.700"
    color="black"
    className='nft-button'
  >
    <option value="asc">Ascending</option>
    <option value="desc">Descending</option>
  </Select>
</Flex>
<NftGrid
  value={value}
  refreshKey={refreshKey}
  token_addresses={tokenaddresses}
  address={searchAddress}
  sortField={sortField}
  sortOrder={sortOrder}
  chain={searchChain}
  onDataLoaded={(nfts) => {
    const collections = nfts.reduce((acc: Record<string, string>, nft: any) => {
      if (!acc[nft.token_address]) {
        acc[nft.token_address] = nft.name || `Unknown (${nft.token_address.slice(0,6)})`;
      }
      return acc;
    }, {});
    setAllCollections(Object.entries(collections));
  }}
/>          
        </Box>
      )}
    </VStack>
  );
};
